import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { Dialog } from "@mui/material";
import FileAttachment from "../UniversalComponents/FileAttachment";

const ApproverDialogue = ({ open, close, onSubmit }) => {
  return (
    <Dialog open={open} fullWidth onClose={close}>
      <div className="p-4 w-full h-full">
        <div className="flex justify-between items-center">
          <span className="text-2C495D font-semibold text-xl">Upload File</span>
          <button
            onClick={close}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto end-0 items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only flex float-end">Close modal</span>
          </button>
        </div>
        <div className="border w-full mt-2"></div>

        <div className="border-none b w-full h-44 text-center mt-5">
          <p>Kindly, attached document</p>
          <p>Tax Paper1</p>
          <p>tax Paper2</p>
          <p>Tax Paper3</p>
        </div>
        <FileAttachment />
        <div className="flex justify-end py-4  text-md w-full">
          <div className="px-6">
            <button onClick={onSubmit} type="button" className="w-28 text-[#FFFFFF] bg-[#1D4469]  rounded-md py-3 px-3">
              send
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ApproverDialogue;
